import { definedProps, type DefinedPropsCoercer } from './definedProps';

export const toQueryList = <T extends { [key: string]: unknown }>(
  data: T,
  coerce?: DefinedPropsCoercer,
  fuzzyList?: readonly (keyof T)[]
) => {
  return definedProps(data, undefined, coerce).map(([key, value]) => ({
    key,
    value,
    op: fuzzyList?.includes(key) ? 'FUZZ' : undefined,
  }));
};
